module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.OnDemandData.length > 0) ? _c('section', [(_vm.OnDemandData[0].title != undefined && _vm.OnDemandData[0].title.rendered != undefined && _vm.OnDemandData[0].title.rendered != null && _vm.OnDemandData[0].title.rendered != '') ? _c('h1', {
    staticClass: "main-title grid-container"
  }, [_vm._v(_vm._s(_vm.OnDemandData[0].title.rendered))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation ross-on-demand layer3"
  }), _vm._v(" "), _c('div', {
    staticClass: "media-list layer2"
  }, [_c('div', {
    staticClass: "grid-container grid-100"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [(_vm.OnDemandData[0].video_url != undefined && _vm.OnDemandData[0].video_url != null && _vm.OnDemandData[0].video_url != '') ? _c('iframe', {
    attrs: {
      "src": _vm.OnDemandData[0].video_url,
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  }) : _vm._e()])])]), _vm._v(" "), _vm._m(0)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-cta grid-100 grid-parent layer1"
  }, [_c('a', {
    staticClass: "layer1",
    attrs: {
      "href": "https://vimeo.com/rossnoble",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("GO TO VIMEO")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/arrow_home_cta.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34323b93","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/OnDemand.vue
// module id = 279
// module chunks = 0